import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { BarChart3, Loader2 } from "lucide-react";
import { ProdHeader, FabricaGate, DataTable, ExportBar, useFabrica, today, addDays, weekStart, fmtData } from "./shared";

const TIPOS = [
  { v: "planejado_realizado", l: "Planejado × realizado" }, { v: "consumo", l: "Consumo previsto × real" }, { v: "custos", l: "Custo previsto × real" },
  { v: "perdas", l: "Perdas, devoluções e sobras" }, { v: "requisicoes", l: "Requisições e entregas" }, { v: "estoque", l: "Estoque por local, lote e validade" },
];

export default function ProducaoRelatorios() {
  const fab = useFabrica();
  const [tipo, setTipo] = useState("planejado_realizado");
  const [ini, setIni] = useState(addDays(weekStart(today()), -21));
  const [fim, setFim] = useState(addDays(weekStart(today()), 6));
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!fab.unitId) return;
    setD(null);
    api.get(`/producao/relatorios/${tipo}`, { params: { unit_id: fab.unitId, ini, fim } }).then((r) => setD(r.data));
  }, [fab.unitId, tipo, ini, fim]);
  const titulo = TIPOS.find((t) => t.v === tipo).l;
  return (
    <div className="space-y-5" data-testid="prod-relatorios-page">
      <ProdHeader title="Relatórios da Produção" icon={BarChart3} fab={fab} />
      <FabricaGate fab={fab}>
        <div className="flex flex-wrap gap-2">{TIPOS.map((t) => <Button key={t.v} size="sm" variant={tipo === t.v ? "default" : "outline"} onClick={() => setTipo(t.v)} data-testid={`rel-${t.v}`}>{t.l}</Button>)}</div>
        <Card className="bg-card/70 p-3 flex flex-wrap items-end gap-3">
          <div><Label className="text-xs">De</Label><Input type="date" value={ini} onChange={(e) => setIni(e.target.value)} data-testid="rel-ini" /></div>
          <div><Label className="text-xs">Até</Label><Input type="date" value={fim} onChange={(e) => setFim(e.target.value)} data-testid="rel-fim" /></div>
          <div className="ml-auto"><ExportBar titulo={titulo} colunas={d?.colunas || []} linhas={d?.linhas || []} filtros={[{ label: "Unidade", valor: fab.unidade?.nome }, { label: "Período", valor: `${fmtData(ini)} a ${fmtData(fim)}` }]} testid="export-rel" /></div>
        </Card>
        {!d ? <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div> : <DataTable colunas={d.colunas} linhas={d.linhas} testid="rel-table" />}
      </FabricaGate>
    </div>
  );
}
